export type Role = 'ADMIN' | 'OPERATOR' | 'VIEWER';

/** EPIC-161 product roles: capability gates are authoritative; minRole stays conservative (VIEWER). */
export const EPIC161_PRODUCT_ROLES = [
  'customer_admin',
  'ehs_manager',
  'operations_supervisor',
  'external_reviewer',
  'product_evaluator',
  'sandbox_ehs_evaluator',
  'executive_viewer',
  'technical_integrator',
] as const;

const LEGACY_ADMIN_ROLES = [
  'admin',
  'administrator',
  'org_admin',
  'site_admin',
  'pilot_site_admin',
  'edgentik_admin',
] as const;

const LEGACY_OPERATOR_ROLES = ['operator', 'ops'] as const;

const LEGACY_VIEWER_ROLES = ['user', 'viewer', 'read', 'readonly'] as const;

export function isEpic161ProductRole(raw?: string | null): boolean {
  const r = (raw || '').toString().toLowerCase().trim();
  return (EPIC161_PRODUCT_ROLES as readonly string[]).includes(r);
}

/**
 * Normalize a raw role string to canonical RBAC-lite ranks for legacy minRole gates only.
 *
 * EPIC-161 product roles map to VIEWER so OPERATOR/ADMIN fallbacks cannot bypass capability checks.
 */
export function normalizeRole(raw?: string | null): Role {
  const r = (raw || '').toString().toLowerCase().trim();
  if ((LEGACY_ADMIN_ROLES as readonly string[]).includes(r)) return 'ADMIN';
  if ((LEGACY_OPERATOR_ROLES as readonly string[]).includes(r)) return 'OPERATOR';
  if ((LEGACY_VIEWER_ROLES as readonly string[]).includes(r)) return 'VIEWER';
  if (isEpic161ProductRole(r)) return 'VIEWER';
  return 'VIEWER';
}

export function roleRank(r: Role): number {
  if (r === 'ADMIN') return 3;
  if (r === 'OPERATOR') return 2;
  return 1;
}

export function hasMinRole(userRole: Role, minRole: Role): boolean {
  return roleRank(userRole) >= roleRank(minRole);
}
